import { Anchor, Box, Button, Heading, Modal, Paragraph } from '@zillow/constellation-10';
import StringConstants from '../../../constants/StringConstants';

const BRAND_NAME = StringConstants.UNFORMATTED_BRAND_NAMES.zillow;
const EMAIL = 'account_verification@zillow.com';

export default function CustomizedBlockedUserModal() {
  return (
    <Modal
      open={true}
      closeButton={false}
      size={{
        base: 'fullScreen',
        md: 'md',
      }}
      header={
        <Heading level={2} textStyle="heading-xs" css={{ textAlign: 'center', paddingLeft: 'loose' }}>
          Alert
        </Heading>
      }
      body={
        <Box css={{ textAlign: 'center' }}>
          <Paragraph textStyle="body-bold" css={{ paddingBottom: 'loose' }}>
            Your account is currently disabled
          </Paragraph>
          <Paragraph css={{ paddingBottom: 'loose' }}>
            We are unable to access your inbox at this time. Please contact{' '}
            <Anchor href={`mailto:${EMAIL}`}>{EMAIL}</Anchor> to resolve the issue.
          </Paragraph>
          <Box css={{ marginBottom: 'default' }}>
            <Button asChild emphasis="filled" tone="brand">
              <a href={`https://www.${BRAND_NAME}.com`}>Return to Zillow</a>
            </Button>
          </Box>
        </Box>
      }
      useDismissProps={{
        escapeKey: false,
        outsidePress: false,
      }}
    />
  );
}
